import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import PropTypes from "prop-types";

import FormAttachmentsView  from "components/FormAttachmentsView";
import { API_AWARD, COLUMN_HEADER_KEYS } from "globals/constants";
import { useFormAccesses } from "hooks";
import { awardSelectors, shellSelectors, tenantSelectors } from "store/selectors";
import { spUrl } from "utils";


const AwardAttachmentsView = ({ tabsRef, formTabText, setJustActivatedSectionLabel, isUploading, setIsUploading }) => {
	const award = useSelector(awardSelectors.award);
	const { fullName } = useSelector(shellSelectors.user);
	const { attachmentTypes } = useSelector(tenantSelectors.tenant);

	const formAccesses = useFormAccesses("award", award.awardId);

	const {
		formInstance,
		attachmentsUrl,
		awardAttachmentTypes,
	} = useMemo(() => ({
		attachmentsUrl: spUrl(`${API_AWARD}/${award.awardId}/attachments`),
		awardAttachmentTypes: attachmentTypes["PROPOSAL"],  //TODO:Do we have attachment types for awards?
		formInstance: {
			instanceId: award.awardId,
			endpoint: API_AWARD,
			type: COLUMN_HEADER_KEYS.AWARD
		},
	}), [ award, attachmentTypes ]);

	return (
		<FormAttachmentsView
			formInstance={formInstance}
			fullName={fullName}
			attachmentTypes={awardAttachmentTypes}
			attachmentsUrl={attachmentsUrl}
			tabsRef={tabsRef}
			formTabText={formTabText}
			canAddAttachments={formAccesses.addContent}
			canEditAttachments={formAccesses.updateContent}
			setJustActivatedSectionLabel={setJustActivatedSectionLabel}
			setIsUploading={setIsUploading}
			isUploading={isUploading}
		/>
	);
};

AwardAttachmentsView.propTypes = {
	setJustActivatedSectionLabel: PropTypes.func.isRequired,
	tabsRef: PropTypes.object,
};

export default AwardAttachmentsView;
